module.exports = __webpack_public_path__ + "static/img/Tom-Flegler.b86add1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tom-Flegler.jpg
// module id = r8T+
// module chunks = 0